import run from '../../utilities/run';
import $ from 'jquery';
import _ from 'underscore';
import render from "../../utilities/render";
import { setSwitchery, enableSwitchery, disableSwitchery, instantiateSwitchery} from '../../utilities/instantiateSwitchery';
import { getMap } from '../orderType/elementsbindMap';
import { isNull, isNullOrUndefined } from 'util';
import { instantiateSelect2 } from "../../utilities/select2able";
import { handleDisplayFor, setElementsFromScope, hide, show, handleDisplayForV2, setDisabled, disableInput, enableInput } from "../../utilities/selectorHelpers";
import { createPreventDefault } from '../../utilities/general';
import { getAdditionalCarrierMap } from '../orderType/elementsbindMap';

const elementsPageMap = getMap();
const additionalCarrierElementsMap = getAdditionalCarrierMap();
const elsPage = {};
const entryEl = $("<div class='entry-point'></div>");
const targetSelector = "#create-order-type-form";
const additionalCarrierHtml = require('./html/AdditonalCarriers.html');




export function loadEditValues(mainEl){
    const editOrderType = mainEl.data("edit-order-type-data");
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
    setElementsFromScope(elsPage, additionalCarrierElementsMap, mainEl);
    fillForDetailsTab(editOrderType, mainEl);
    fillForPackagingTab(editOrderType, mainEl); 
}

function fillForDetailsTab(orderTypeObj,el){    

    if(! isNullOrUndefined(orderTypeObj.fulfillmentCenter))
        elsPage.orderTypeFullfillmentCenter.val(orderTypeObj.fulfillmentCenter).trigger('change');

    if(! isNullOrUndefined(orderTypeObj.billing))
        elsPage.orderTypeBillingMethod.val(orderTypeObj.billing.billingMethod).trigger('change'); 
        if(orderTypeObj.billing.billingMethod.toUpperCase() != "PREPAID"){
            if (!isNullOrUndefined(orderTypeObj.billing.carriers[0])) {
                if (orderTypeObj.billing.carriers[0].carrierName.toUpperCase() == 'FEDEX') {
                    elsPage.orderTypeCarrier.val(orderTypeObj.billing.carriers[0].carrierName).trigger('change');
                    elsPage.orderTypeFedexAccountNumber.val(orderTypeObj.billing.carriers[0].accountNumber);
                } else {
                    elsPage.orderTypeCarrier.val(orderTypeObj.billing.carriers[0].carrierName).trigger('change');
                    elsPage.orderTypeUpsAccountNumber.val(orderTypeObj.billing.carriers[0].accountNumber);
                    elsPage.orderTypeBillto.val(orderTypeObj.billing.carriers[0].billToAddress.name);
    
                    if(! isNullOrUndefined(orderTypeObj.billing.carriers[0].billToAddress))
                    elsPage.orderTypeDetailCountry.val(orderTypeObj.billing.carriers[0].billToAddress.country).trigger('change'); 
    
                    elsPage.orderTypeDetailAddress.val(orderTypeObj.billing.carriers[0].billToAddress.addressLine1);
                    if(!isNullOrUndefined(orderTypeObj.billing.carriers[0].billToAddress.addressLine2)){
                        elsPage.orderTypeDetailAddress2.val(orderTypeObj.billing.carriers[0].billToAddress.addressLine2);
                    }
                    elsPage.orderTypeDetailCity.val(orderTypeObj.billing.carriers[0].billToAddress.city);
    
                    if(! isNullOrUndefined(orderTypeObj.billing.carriers[0].billToAddress))
                    elsPage.orderTypeDetailState.val(orderTypeObj.billing.carriers[0].billToAddress.state).trigger('change'); 
    
                    elsPage.orderTypeDetailStateInput.val(orderTypeObj.billing.carriers[0].billToAddress.state);
                    elsPage.orderTypeDetailPostalcode.val(orderTypeObj.billing.carriers[0].billToAddress.postalCode);
                }
            }
            
            if (!isNullOrUndefined(orderTypeObj.billing.carriers[1])) {
                let arrayIndex = 0;
                const carrierList = elsPage.orderTypeCarrier.data('options');
                const countryList = elsPage.orderTypeDetailCountry.data('options');
                const AdditonalCarriersAdd = $(render(additionalCarrierHtml, {
                    additionalCarrierDropdown: getRenderedCarrierDropDown(carrierList, orderTypeObj.billing.carriers[0].carrierName),
                    countryList: renderCountryList(countryList),
                    arrayIndex
                }));
                elsPage.orderTypedetailAddcarrierDiv.append(AdditonalCarriersAdd);
                instantiateSelect2(elsPage.orderTypedetailAddcarrierDiv.find('.select2-select'));
                fillForAdditionalCarrier(orderTypeObj.billing.carriers[1],el);
            }
        }
        
}

function getRenderedCarrierDropDown(addtionalCarrierDropValue, valueForMainCarrier) {
    const carrierValue = elsPage.orderTypeCarrier.val();
    const addtionalCarrierDropHtml = '<option value="{%- addtionalCarrier.cdmValue %}">{%- addtionalCarrier.cdmValue %}</option>';
    const response = _.map(addtionalCarrierDropValue, (addtionalCarrier) => {
        if(valueForMainCarrier != addtionalCarrier.cdmValue){
            return render(addtionalCarrierDropHtml, {
                addtionalCarrier: addtionalCarrier
            });
        }
    });
    return response.join("");
}

function renderCountryList(countryList) {
    const addtionalCarrierCountryDropHtml = '<option value="{%- addtionalCarrierCountry.conCode %}">{%- addtionalCarrierCountry.conName %}</option>';
    const response = _.map(countryList, (addtionalCarrierCountry) => {
        return render(addtionalCarrierCountryDropHtml, {
            addtionalCarrierCountry: addtionalCarrierCountry
        });
    });

    return response.join("");
}

function fillForAdditionalCarrier(billing,el){
    handleSwitchingStateAddtionaCarrier();
    setElementsFromScope(elsPage, additionalCarrierElementsMap, el);
    if (billing.carrierName.toUpperCase() == 'FEDEX') {
        elsPage.additionalCarrierDrop.val(billing.carrierName).trigger('change');
        elsPage.additionalCarrierFedexNumber.val(billing.accountNumber);
    } else {
        elsPage.additionalCarrierDrop.val(billing.carrierName).trigger('change');
        elsPage.additionalCarrierUPSNumber.val(billing.accountNumber);
        elsPage.additionalCarrierBillTo.val(billing.billToAddress.name);
        elsPage.additionalCarrierCountry.val(billing.billToAddress.country).trigger('change'); 
        elsPage.additionalCarrierAddress1.val(billing.billToAddress.addressLine1);
        if(!isNullOrUndefined(billing.billToAddress.addressLine2)){
            elsPage.additionalCarrierAddress2.val(billing.billToAddress.addressLine2);
        }
        elsPage.additionalCarrierCity.val(billing.billToAddress.city);
        elsPage.additionalCarrierDetailState.val(billing.billToAddress.state).trigger('change'); 
        elsPage.additionalCarrierDetailStateText.val(billing.billToAddress.state);
        elsPage.additionalCarrierPostalCode.val(billing.billToAddress.postalCode);
    }
}

function handleSwitchingStateAddtionaCarrier() {

    let countryVal = $('.additional-carrier-country  :selected').val();
    if (countryVal == "US" || countryVal == "CA") {
        elsPage.additionalCarrierDetailStateWrapper.removeClass("hidden");
        elsPage.additionalCarrierDetailStateTextWrapper.addClass("hidden");
        getRenderedStatesorProvince(countryVal, elsPage.additionalCarrierDetailState);
    }
    else {
        elsPage.additionalCarrierDetailStateWrapper.addClass("hidden");
        elsPage.additionalCarrierDetailStateTextWrapper.removeClass("hidden");
    }
}
    
function getRenderedStatesorProvince(countryVal, stateComponent) {
    const stateTypeSelect = stateComponent;
    stateTypeSelect.html('');
    let defaultSelectText = "";
    if (countryVal == "US") {
        defaultSelectText = "Select State";
    } else {
        defaultSelectText = "Select Province";
    }
    let option = $('<option />');
    option.attr('value', "-1").text(defaultSelectText);
    option.attr('selected', 'selected');
    option.attr('disabled', 'disabled');
    stateTypeSelect.append(option);
    if (countryVal == "US") {
        $(usaStates).each(function () {
            let option = $('<option />');
            option.attr('value', this.cdmValue).text(this.cdmMeaning);
            stateTypeSelect.append(option);
        });
    }
    else if (countryVal == "CA") {
        $(caProvinces).each(function () {
            let option = $('<option />');
            option.attr('value', this.cdmValue).text(this.cdmMeaning);
            stateTypeSelect.append(option);
        });
    }
    stateTypeSelect.addClass("select2 select");
    instantiateSelect2(stateTypeSelect);
}

function fillForPackagingTab(editOrderType, el){

    elsPage.orderTypeBoxType.val(editOrderType.boxType).trigger('change');
    elsPage.orderTypeTissuePaper.val(editOrderType.tissuePaper).trigger('change');
    instantiateSwitchery(elsPage.includePackageLabel, {});
    instantiateSwitchery(elsPage.packagePackingSlip, {});
    instantiateSwitchery(elsPage.orderPackingSlip, {});
    setSwitchery(elsPage.includePackageLabel,editOrderType.includingPackageLabel);
    if(editOrderType.packingSlipCI.includingPackingSlip){
        setSwitchery(elsPage.packagePackingSlip,true);
        elsPage.packageSlip.val(editOrderType.packingSlipCI.packingSlipTemplate).trigger('change');
    }else{
        setSwitchery(elsPage.packagePackingSlip,false);
    }

    if(editOrderType.packingSlipCI.includingCI){
        setSwitchery(elsPage.orderPackingSlip,true);
        elsPage.orderSlip.val(editOrderType.packingSlipCI.citemplate).trigger('change');
    }else{
        setSwitchery(elsPage.orderPackingSlip,false);
    }

    if(editOrderType.packingSlipCI.includingCI || editOrderType.packingSlipCI.includingPackingSlip)
       elsPage.customizeSection.show();

    elsPage.companyNameInput.val(editOrderType.packingSlipCI.customizedDocument.companyName);
    elsPage.customDocEmail.val(editOrderType.packingSlipCI.customizedDocument.contactEmail);
    elsPage.customHeader.val(editOrderType.packingSlipCI.customizedDocument.customNoteHeader);
    elsPage.customBody.val(editOrderType.packingSlipCI.customizedDocument.customNoteBody);
    elsPage.customDocPhoneNumber.val(editOrderType.packingSlipCI.customizedDocument.phoneNumber);
    elsPage.orderTypeCountryCode.val(editOrderType.packingSlipCI.customizedDocument.countryCode).trigger('change');
    if(!isNullOrUndefined(editOrderType.packingSlipCI.customizedDocument.facility)){
        elsPage.facilityAddress.val(editOrderType.packingSlipCI.customizedDocument.facility.facilityName).trigger('change');
    }

    
}








// WEBPACK FOOTER //
// ./src/pages/orderType/editOrderTypeWizard.js